import React, { ReactElement } from 'react';
import Snackbar from '@mui/material/Snackbar';
import TextBlock from '../text-block/text-block.component';
import ActionButton from '../action-button/action-button.component';
import IconBlockWarning from '../icon-block-warning/icon-block-warning.component';
import IconBlockSuccess from '../icon-block-success/icon-block-success.component';
import CloseIcon from '../../icons/close-icon';
import FormatService from '../../services/format-service';
import useStylesStatusBar from './status-bar.styles';

const StatusBar: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_INHERIT: ThemeColor = 'inherit';
  const ANCHOR_BOTTOM: SnackBarAnchor = 'bottom';
  const ANCHOR_LEFT: SnackBarAnchor = 'left';
  const AUTO_HIDE_DURATION: number = 3000;

  const {
    isOpen,
    isError,
    message,
    onClose,
  } = props;

  const { classes } = useStylesStatusBar();

  const errorClassName: string | undefined = isError ? classes.statusBarError : undefined;

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={AUTO_HIDE_DURATION}
      className={classes.statusBarContainer}
      ContentProps={{
        classes: {
          root: FormatService.formatClassNames(classes.statusBar, errorClassName),
        },
      }}
      anchorOrigin={{
        vertical: ANCHOR_BOTTOM,
        horizontal: ANCHOR_LEFT,
      }}
      onClose={onClose}
      message={(
        <TextBlock>
          <TextBlock className={classes.statusBarIcon}>
            {isError ? <IconBlockWarning isDisabled /> : <IconBlockSuccess isDisabled />}
          </TextBlock>
          <TextBlock>
            {message}
          </TextBlock>
        </TextBlock>
      )}
      action={(
        <ActionButton
          color={COLOR_INHERIT}
          onClick={onClose}
          classes={{
            root: classes.statusBarButton,
          }}
        >
          <CloseIcon />
        </ActionButton>
      )}
    />
  );
});

export default StatusBar;
